import React from "react";
import * as crossfilter from "crossfilter2";
import {csv,timeFormat,timeParse,timeMonth,format} from 'd3';
import * as dc from "dc";
import "dc/dc.css";
//import data from './data3a.csv';

export const CXContext = React.createContext("CXContext");
export const  dateFormatSpecifier = '%m/%d/%Y %H:%M';
export const dateFormat = timeFormat(dateFormatSpecifier);
export const dateFormatParser = timeParse(dateFormatSpecifier);
export const numberFormat = format('.2f');

const serviceLevel = 30;
const data = 'https://baloka.com/Visualization/data3a.csv';

const tags = []
export class DataContext extends React.Component {
  constructor(props) {
    super(props);
    this.state={loading:false,hasNDX:false};
  }

  componentDidMount(){
      if (this.state.hasNDX){
          return
      }
      if(this.state.loading){
          return
      }
      this.setState({loading:true})

      //  self = this;

      //csv('https://lighttag.github.io/dcjs-in-react/ndx.csv')
      //'http://twnelwebsite.azurewebsites.net/fakedata/data.csv'
      let l = 0;
      let tags = [];
      csv(data)
        .then((data)=> {
            data.forEach(function (d) {
                d.dincoming = new Date(d.incoming_time);
                d.dreserved = new Date(d.reserved_time);
                d.dclosed = new Date(d.closed_time);
                d.wait_time = parseFloat((d.dreserved - d.dincoming)/60000);
                d.conversation_time = parseFloat((d.dclosed - d.dincoming)/60000);   //d.dclosed - d.dreserved;
                d.day = +d.dincoming.getDay();
                d.hour = +d.dincoming.getHours();
                d.slevel = +0;
                if(d.wait_time <= 30) {
                  d.s_level = '<= 30 secs';
                  d.slevel = +1;
                }
                else if(d.wait_time > 30 && d.wait_time <= 60) d.s_level = '30+ - 60 secs';
                else if(d.wait_time > 60 && d.wait_time <= 120) d.s_level = '60+ - 120 secs';
                else if(d.wait_time > 120 && d.wait_time <= 180) d.s_level = '120+ - 180 secs';
                else  d.s_level = '> 3 minutes';
                d.tags = d.tags.split(",");
                d.tag = [];
                for(var i=0; i<20; i++){
                  d.tag.push('');
                }

                for(i=0; i<d.tags.length; i++) {
                  if(d.tags[i] != ' '){
                    if(tags.indexOf(d.tags[i]) == -1) {
                        tags.push(d.tags[i])
                    }

                    const index = tags.indexOf(d.tags[i]);
                    d.tag[index] = d.tags[i];
                  }
                }
            });

            this.tags = tags;

            this.ndx = crossfilter(data); //TODO possibly need to update this

            this.setState({loading:false,hasNDX:true});
        })
  }

  render() {
      if(!this.state.hasNDX){
          return null;
      }
    return (
      <div>
        <div ref={(el) => { this.datanumber = el; }}> </div>
        <CXContext.Provider value={{ndx:this.ndx, tags:this.tags, index:''}}>
          <div ref={this.parent} >
          {this.props.children}
          </div>
        </CXContext.Provider>
      </div>
    );
  }
}
